<template>
  <aw-sf-recommendation
    page="product"
    :bordered="isOnWhiteCard"
    :for-items="forItems"
    :analytics-banner-interaction="analyticsBannerInteraction"
    :analytics-measurable="analyticsMeasurable"
  />
</template>

<script setup>
  import cmsPageComponentMixin from '~~/common/mixins/cmsPageComponentMixin.js';
  import AwSfRecommendation from '~~/common/components/Common/AwSfRecommendation.vue';
  import { useProductStore } from '~~/common/stores/product';
  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin';

  defineProps({
    ...cmsPageComponentMixin.props,
    ...analyticsBannerInteractionMixin.props,
    content: {
      type: Object,
      required: true,
    },
  });

  const forItems = useProductStore().data?.selectedVariant?.sku?.toString();
</script>
